(function () {
  'use strict';

  var STYLE_ID = 'tiffy-price-filter-fix-style';
  var INPUT_CLASS = 'tiffy-price-input';
  var fieldCounter = 0;

  function addStyles() {
    var existing = document.getElementById(STYLE_ID);
    if (existing) existing.remove();

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.price-range{box-sizing:border-box!important}',
      '.tiffy-price-filter,.tiffy-price-filter *{box-sizing:border-box!important}',
      '.tiffy-price-filter{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;column-gap:14px!important;row-gap:13px!important;align-items:start!important;width:100%!important;margin:0!important;padding:10px 10px 7px 0!important}',
      '.tiffy-price-field{display:flex!important;flex-direction:column!important;min-width:0!important;width:100%!important;margin:0!important;padding:0!important}',
      '.tiffy-price-label{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:7px!important;min-height:15px!important;width:100%!important;margin:0 0 8px!important;padding:0!important;color:rgba(45,45,42,.82)!important;font-family:inherit!important;font-size:11px!important;font-weight:500!important;line-height:1!important;letter-spacing:.17em!important;text-transform:uppercase!important;white-space:nowrap!important}',
      '.tiffy-price-label-text,.tiffy-price-currency{display:block!important;line-height:1!important;white-space:nowrap!important}',
      '.tiffy-price-currency{color:rgba(45,45,42,.56)!important;font-size:9px!important;font-weight:400!important;letter-spacing:.12em!important}',
      '.tiffy-price-input{display:block!important;position:static!important;visibility:visible!important;opacity:1!important;width:100%!important;min-width:0!important;height:46px!important;margin:0!important;padding:0 13px!important;border:1px solid rgba(61,61,57,.34)!important;border-radius:1px!important;background:#fff!important;color:rgba(38,38,35,.92)!important;box-shadow:none!important;font-family:inherit!important;font-size:14px!important;font-weight:400!important;line-height:46px!important;letter-spacing:.025em!important;appearance:textfield!important;-webkit-appearance:none!important;transition:border-color .2s ease,box-shadow .2s ease!important}',
      '.tiffy-price-input::placeholder{color:rgba(50,50,46,.43)!important;opacity:1!important}',
      '.tiffy-price-input:hover{border-color:rgba(61,61,57,.58)!important}',
      '.tiffy-price-input:focus{outline:none!important;border-color:#666c58!important;box-shadow:0 0 0 1px #666c58!important}',
      '.tiffy-price-input::-webkit-outer-spin-button,.tiffy-price-input::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0!important}',
      '.tiffy-price-apply{grid-column:1/-1!important;display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-width:0!important;height:49px!important;min-height:49px!important;margin:3px 0 0!important;padding:0 20px!important;border:1px solid #646a57!important;border-radius:2px!important;background:#646a57!important;color:#fff!important;box-shadow:none!important;font-family:inherit!important;font-size:12px!important;font-weight:600!important;line-height:1!important;letter-spacing:.24em!important;text-align:center!important;text-indent:.24em!important;text-transform:uppercase!important;appearance:none!important;-webkit-appearance:none!important;cursor:pointer!important;transition:background-color .2s ease,border-color .2s ease!important}',
      '.tiffy-price-apply:hover,.tiffy-price-apply:focus{background:#565c4b!important;border-color:#565c4b!important;color:#fff!important;outline:none!important;transform:none!important}',
      '.tiffy-price-apply:focus-visible{box-shadow:0 0 0 2px #fff,0 0 0 3px #565c4b!important}',
      '.tiffy-price-hint{grid-column:1/-1!important;width:100%!important;margin:-2px 0 0!important;padding:0!important;color:rgba(45,45,42,.52)!important;font-family:inherit!important;font-size:10px!important;font-weight:400!important;line-height:1.45!important;letter-spacing:.055em!important;text-align:left!important}',
      '@media(max-width:480px){.tiffy-price-filter{column-gap:10px!important;row-gap:12px!important;padding-right:7px!important}.tiffy-price-label{font-size:10px!important;letter-spacing:.13em!important}.tiffy-price-currency{font-size:8px!important}.tiffy-price-input{height:45px!important;line-height:45px!important;padding:0 11px!important}.tiffy-price-apply{height:47px!important;min-height:47px!important}}',
      '@media(max-width:340px){.tiffy-price-filter{grid-template-columns:1fr!important}.tiffy-price-apply,.tiffy-price-hint{grid-column:1!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function stopAutoApply(event) {
    event.stopPropagation();
  }

  function formatPlaceholder(value, fallback) {
    var number = parseFloat(value);
    if (!isFinite(number)) return fallback;
    return number.toFixed(2);
  }

  function makeField(labelText, currency, name, value, placeholder, min, max) {
    fieldCounter += 1;

    var field = document.createElement('div');
    field.className = 'tiffy-price-field';

    var inputId = 'TiffyPriceInput-' + fieldCounter;
    var label = document.createElement('label');
    label.className = 'tiffy-price-label';
    label.setAttribute('for', inputId);

    var labelName = document.createElement('span');
    labelName.className = 'tiffy-price-label-text';
    labelName.textContent = labelText;
    label.appendChild(labelName);

    if (currency) {
      var currencyLabel = document.createElement('span');
      currencyLabel.className = 'tiffy-price-currency';
      currencyLabel.textContent = currency;
      label.appendChild(currencyLabel);
    }

    var input = document.createElement('input');
    input.id = inputId;
    input.type = 'number';
    input.inputMode = 'decimal';
    input.step = '0.01';
    input.className = INPUT_CLASS;
    input.name = name;
    input.value = value || '';
    input.placeholder = placeholder || '';
    if (min !== '') input.min = min;
    if (max !== '') input.max = max;
    input.setAttribute('aria-label', labelText + (currency ? ' (' + currency + ')' : ''));
    input.addEventListener('change', stopAutoApply);
    input.addEventListener('input', stopAutoApply);

    field.appendChild(label);
    field.appendChild(input);
    return field;
  }

  function bindForm(form) {
    if (!form || form.dataset.tiffyPriceSubmitBound === '1') return;
    form.dataset.tiffyPriceSubmitBound = '1';

    form.addEventListener('submit', function () {
      var inputs = form.querySelectorAll('.' + INPUT_CLASS);
      inputs.forEach(function (input) {
        var value = String(input.value || '').trim().replace(',', '.');
        input.value = value;
        input.disabled = value === '';
      });
    }, true);
  }

  function enhanceRange(range) {
    if (!range || range.dataset.tiffyPriceFixed === '1') return;

    var minName = range.dataset.minName || '';
    var maxName = range.dataset.maxName || '';
    if (!minName || !maxName) return;

    range.dataset.tiffyPriceFixed = '1';

    var oldMin = range.querySelector('.price-range__input-min');
    var oldMax = range.querySelector('.price-range__input-max');
    [oldMin, oldMax].forEach(function (input) {
      if (!input) return;
      input.removeAttribute('name');
      input.disabled = true;
      input.style.display = 'none';
    });

    var display = range.querySelector('.price-range__display-wrapper');
    var slider = range.querySelector('.price-range__slider-wrapper');
    if (display) display.style.display = 'none';
    if (slider) slider.style.display = 'none';

    var minBound = range.dataset.min || '0';
    var maxBound = range.dataset.max || '';
    var minValue = range.dataset.minValue || '';
    var maxValue = range.dataset.maxValue || '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

    var controls = document.createElement('div');
    controls.className = 'tiffy-price-filter';
    controls.appendChild(makeField('From', currency, minName, minValue, formatPlaceholder(minBound, '0.00'), minBound, maxBound));
    controls.appendChild(makeField('To', currency, maxName, maxValue, formatPlaceholder(maxBound, ''), minBound, maxBound));

    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'tiffy-price-apply';
    button.textContent = 'Apply';
    controls.appendChild(button);

    if (maxBound) {
      var hint = document.createElement('p');
      hint.className = 'tiffy-price-hint';
      hint.textContent = 'Maximum: ' + formatPlaceholder(maxBound, maxBound) + (currency ? ' ' + currency : '');
      controls.appendChild(hint);
    }

    range.appendChild(controls);
    bindForm(range.closest('form'));
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.price-range').forEach(enhanceRange);
  }

  function start() {
    addStyles();
    enhance(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.price-range')) enhanceRange(node);
          enhance(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();